export const STUDIO_BACKEND = 'https://apps.api.manifoldxyz.dev';

export const studioApiBaseUrl =
  process.env.NODE_ENV === 'development' && process.env.VUE_APP_STUDIO_API_URL // must be defined if true
    ? process.env.VUE_APP_STUDIO_API_URL
    : `${STUDIO_BACKEND}`;

/**
 * @WARN: DOES NOT HANDLE BEARER/AUTHORIZATION
 */
class APIHelpers {
  static getHeaders (): {'Accept': string; 'Content-Type'?: string;} {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'Authorization': ...
    };
  }

  static fetch(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'GET', query);
  }

  static patch(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'PATCH', query);
  }

  static post(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'POST', query);
  }

  static delete(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'DELETE', query);
  }

  static async sendRequest (
    path: string,
    options: RequestInit = {},
    method: string,
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    try {
      let url = studioApiBaseUrl + path;

      if (query) {
        const queryString = new URLSearchParams(query).toString();
        url = url + '?' + queryString;
      }

      const requestOptions = {
        method: method,
        headers: this.getHeaders(),
        ...options,
      };

      if (options.body) {
        requestOptions.body = JSON.stringify(options.body);
      }

      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        throw response;
      }
      let result;
      try {
        result = await response.text();
        return JSON.parse(result);
      } catch (e) {
        return result;
      }
    } catch (error: any) { // eslint-disable-line
      let response = error;
      try {
        response = await response.text();
        throw JSON.parse(response);
      } catch (e) {
        throw response;
      }
    }
  }
}

export default APIHelpers;
